import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import {
	compareProduct,
	removeCompareProduct,
} from '../../redux/product/productActions';
import { fetchCategories } from '../../redux/content/contentActions';
import { changeHead } from '../../redux/head/headActions';

import pageConfig from '../../config/page.config';
import { breadcrumbConfig } from '../../config/breadcrumb.config';
import { ABreadCrumb } from '../../components/atoms';
import { OCompareDetail, OCompareTable, OProductsLoadMore } from '../../components/organisme';

let isPrimarySet = false;
const mapStateToProps = (state) => {
	isPrimarySet = !get(state, 'product.compare.primary', false);

	return {
		primary: state.product.compare.primary,
		secondary: state.product.compare.secondary,
		language: state.head.language,
		categories: state.content.category,
	};
};

class ProductComparePage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			primary: get(props, 'primary', undefined),
			secondary: get(props, 'secondary', undefined),
		};

		this.bindHandles();

		if (isPrimarySet) {
			this.handleGoBack();
		}
	}

	componentDidMount() {
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');

		this.slug = this.props.match.params.slug ? this.props.match.params.slug : 'rent';
		this.props.fetchCategories(crumbs[0]);
		this.props.changeHead({
			id: pageConfig.productCompare.id,
			title: this.props.intl.formatMessage({ id: pageConfig.productCompare.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.productCompare.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			primary: get(props, 'primary', undefined),
			secondary: get(props, 'secondary', undefined),
		});
	}

	bindHandles() {
		this.handleRemoveFirstProduct = this.handleRemoveFirstProduct.bind(this);
		this.handleRemoveSecondProduct = this.handleRemoveSecondProduct.bind(this);
		this.handleGoBack = this.handleGoBack.bind(this);
	}

	handleRemoveFirstProduct() {
		this.props.removeCompareProduct(this.state.primary);
		this.handleGoBack();
	}
	handleRemoveSecondProduct() {
		this.props.removeCompareProduct(this.state.secondary);
	}
	handleGoBack() {
		this.props.history.push(`/${this.props.match.url.split('/').slice(1, 3).join('/')}/${this.props.match.params.category}`);
	}

	render() {
		const url = this.props.match.url.split('/').filter(item => item !== '').slice(0, -1);
		const translatedUrl = url.slice(0, url.length - 3).map(crumb => breadcrumbConfig[crumb][this.props.language]);
		const currentUrl = url.slice(url.length - 3).pop() === 'rent' ? { name: breadcrumbConfig.rent[this.props.language] } :
			this.props.categories.find(category => category.slug === url[url.length - 2]);
		let relatedProducts;

		translatedUrl.push(get(currentUrl, 'name', ''));

		if (get(this.state, 'primary.relatedProduct', false) && this.state.primary.relatedProduct.length) {
			relatedProducts = (
				<OProductsLoadMore
					title="PRODUCT_DETAIL.SIMILAR_PRODUCTS"
					buttonValue="PRODUCT_DETAIL.LOAD_MORE_PRODUCTS"
					items={this.state.primary.relatedProduct}
					loadMore={() => { }}
					className="section-xx layout-body"
				/>
			);
		}


		return (
			<section className="section--breadcrumb">
				<article className="article--breadcrumb">
					<ABreadCrumb
						currentPage={breadcrumbConfig.compare[this.props.language]}
						parents={translatedUrl}
						mappedUrl={url.slice(0, -1)}
					/>
				</article>,
				<div className="section-xx layout-body">
					<OCompareDetail
						product1={this.state.primary}
						product2={this.state.secondary}
						onNewProduct={this.handleGoBack}
						onRemoveProduct1={this.handleRemoveFirstProduct}
						onRemoveProduct2={this.handleRemoveSecondProduct}
					/>
				</div>,
				<div className="section-xx layout-body">
					<OCompareTable
						product1={this.state.primary}
						product2={this.state.secondary}
					/>
				</div>
				{relatedProducts}
			</section >
		);
	}
}

ProductComparePage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	fetchCategories: PropTypes.func.isRequired,
	compareProduct: PropTypes.func.isRequired,
	removeCompareProduct: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHead,
	compareProduct,
	fetchCategories,
	removeCompareProduct,
})(injectIntl(ProductComparePage)));



// WEBPACK FOOTER //
// ./src/pages/producten/product-compare.page.js